import { OperatorOption, formatUserFullName } from './registeredByOperators';

type PersonLike = { id: string; name?: string | null; surName?: string | null };
type AppUserLike = PersonLike & {
  userType?: string | null;
  isActive?: boolean | null;
};

/**
 * Opciones del desplegable «Operario» del formulario de DUPLICAR OT o
 * comunicación: quién figurará como autor del duplicado.
 *
 *  - Usuarios APP activos del tenant (`FETCH_APP_USERS`); fuera los inactivos
 *    y los operarios, que no son cuentas que inicien sesión.
 *  - El logueado el PRIMERO, aunque la consulta no lo traiga: es la elección
 *    habitual y así está a un toque.
 *  - El resto por orden alfabético, para buscar a ojo además de tecleando.
 *  - El autor ORIGINAL siempre presente —al final si hubo que añadirlo—: es
 *    el valor con el que arranca el formulario, y sin él el desplegable
 *    saldría vacío si ese usuario ya no está activo.
 *
 * Mismo patrón que `buildRegisteredByOperators` («Registrado por»), con otra
 * lista: aquella son operarios; esta, usuarios app.
 *
 * Spec: docs/superpowers/specs/2026-09-24-duplicar-operario-editable-design.md § 3
 */
export const buildAppUserOptions = (
  appUsers: AppUserLike[] | undefined | null,
  me: PersonLike | null | undefined,
  originalAuthor: PersonLike | null | undefined,
): OperatorOption[] => {
  const toOption = (user: PersonLike): OperatorOption => ({
    id: user.id,
    name: formatUserFullName({
      id: user.id,
      name: user.name ?? undefined,
      surName: user.surName ?? undefined,
    }),
  });

  const others = (appUsers ?? [])
    .filter(
      (user) =>
        user.isActive !== false &&
        (user.userType ?? 'app-user') === 'app-user' &&
        user.id !== me?.id
    )
    .map(toOption)
    .sort((a, b) => a.name.localeCompare(b.name, 'es'));

  const options = me?.id ? [toOption(me), ...others] : others;

  if (originalAuthor?.id && !options.some((o) => o.id === originalAuthor.id)) {
    options.push(toOption(originalAuthor));
  }
  return options;
};
